module.exports = __webpack_public_path__ + "static/media/shutterstock_629908583.0b2e24c6.jpg";